// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wabnuxerjnecrjynyyfo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndhYm51eGVyam5lY3JqeW55eWZvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxMjAyNzgsImV4cCI6MjA2MzY5NjI3OH0.nEVeueUnAOSmmdE-KKrvFyLWoIlM2zyTMJjmTU1PBUk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);